import React from "react";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CheckIcon from "@mui/icons-material/Check";
import "./PolygonCard.css";
import { STATUS } from "../../../conts/simulationConstants";

export const getPolygonStatus = (p) =>
  p.drawing ? "drawing" : p.feature ? "drawn" : "empty";

const PolygonCard = ({
  id,
  title,
  subtitle,
  polygon,
  onDraw,
  onImport,
  onSelectHistoric,
    disabled = false,
}) => {
  const status = getPolygonStatus(polygon);
  const { label } = STATUS[status];
  const hint =
    status === "drawing"
      ? `${polygon.vertices ?? 0} sommets posés. Double-cliquez sur la carte pour fermer le polygone.`
      : null;

  return (
    <div className={`polygon-card polygon-card--${id} polygon-card--${status}`}>
      <div className="polygon-card__head">
        <span className="polygon-card__swatch" />
        <div className="polygon-card__titles">
          <strong>{title}</strong>
          <small>{subtitle}</small>
        </div>

        <span
          className={`polygon-card__badge${
            status === "drawn" ? " polygon-card__badge--drawn" : ""
          }`}
        >
          {status === "drawn" && (
            <CheckIcon style={{ fontSize: 14, marginRight: 4 }} />
          )}
          {label}
        </span>
      </div>

      {hint && <p className="polygon-card__hint">{hint}</p>}

      <div className="polygon-card__actions">
        {/* {id === "real" ? (
          <button type="button" className="polygon-card__btn polygon-card__btn--soft" onClick={onSelectHistoric}>
            <HistoryIcon fontSize="small" /> Sélectionner un feu historique
          </button>
        ) : (
          <button type="button" className="polygon-card__btn polygon-card__btn--soft" onClick={() => onDraw(id)}>
            <BrushOutlinedIcon fontSize="small" /> {action}
          </button>
        )} */}

        <button
  type="button"
  className="polygon-card__btn polygon-card__btn--outline"
  onClick={() => onImport(id)}
  disabled={disabled}
>
  <FileUploadOutlinedIcon fontSize="small" /> Importer
</button>

        {status === "drawn" && polygon.area != null && (
          <span className="polygon-card__area">{polygon.area} ha</span>
        )}
      </div>
    </div>
  );
};

export default PolygonCard;